
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { WorkflowItemProps } from ".";
import { loading, update } from "store/workflow";
import { AppMessage } from "components";

interface ApiWorkflowUpdateInputProps extends WorkflowItemProps {
}

type ApiWorkflowUpdateOutputProps = OutputBaseProps<{ item: WorkflowItemProps; }, ApiWorkflowUpdateInputProps>

export const apiWorkflowUpdate = async (data: ApiWorkflowUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiWorkflowUpdateOutputProps>("/api/workflow/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};